"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResolveLocalizedString = void 0;
const assert_1 = require("tsafe/assert");
const noUndefined_1 = require("tsafe/noUndefined");
/** @see <https://docs.i18nifty.dev/api-reference/localizedstring> */
function createResolveLocalizedString(params) {
    const { currentLanguage, fallbackLanguage } = params;
    function resolveLocalizedString(localizedString) {
        if (typeof localizedString === "string") {
            return localizedString;
        }
        localizedString = (0, noUndefined_1.noUndefined)(localizedString);
        {
            const text = localizedString[currentLanguage];
            if (typeof text === "string") {
                return text;
            }
        }
        {
            const text = localizedString[fallbackLanguage];
            if (typeof text === "string") {
                return text;
            }
        }
        const text = Object.entries(localizedString)[0][1];
        (0, assert_1.assert)(typeof text === "string", "Must contain at least one value");
        return text;
    }
    return { resolveLocalizedString };
}
exports.createResolveLocalizedString = createResolveLocalizedString;
